export default __webpack_public_path__ + "0c34d1f1a05e58f8fc12f07fb3a30cfc.png";